import React from "react";
import { useAuth0 } from "@auth0/auth0-react";
import ButtonIcon from "components/ButtonIcon/ButtonIcon.tsx";

const LOGIN_RECORDED_SESSION_KEY = "kaboodle.loginAnalyticsRecorded";
const LOGIN_RECORDED_RECENTLY_KEY = "kaboodle.loginAnalyticsRecordedRecently";
const LOGIN_RECORDING_LOCK_KEY = "kaboodle.loginAnalyticsLock";
const SESSION_GUARD_TOKEN_KEY = "kaboodle.sessionGuardToken";

const LogoutButton = () => {
  const { logout } = useAuth0();

  return (
    <ButtonIcon
      data-testid="logout-button"
      onClick={() => {
        sessionStorage.removeItem(LOGIN_RECORDED_SESSION_KEY);
        localStorage.removeItem(LOGIN_RECORDED_RECENTLY_KEY);
        localStorage.removeItem(LOGIN_RECORDING_LOCK_KEY);
        sessionStorage.removeItem(SESSION_GUARD_TOKEN_KEY);
        localStorage.removeItem(SESSION_GUARD_TOKEN_KEY);
        logout({
          logoutParams: { returnTo: `${window.location.origin}` },
        });
      }}
    >
      logout
    </ButtonIcon>
  );
};

export default LogoutButton;
